import { HttpErrorResponse } from '@angular/common/http';
import { throwError} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from './util/notification.service';

export abstract class BaseService {
  constructor(
    protected readonly notificationService: NotificationService,
    protected translate: TranslateService
  ) {}

  protected handleError(error: Response | any, errMsg?: string) {
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      if (!navigator.onLine) {
        // Handle offline error
        this.translate.get('ERROR.NO_CONNEXION').subscribe((res: string) => {
          errMsg = res;
        });
      } else {
         // Handle 500, 501, 502... errors
        if (error.status.toString().startsWith('5')) {
          this.translate.get('ERROR.INTERNAL_SERVER').subscribe((res: string) => {
            errMsg = res;
          });
        } else {
          // Handle Http Error (error.status === 403, 404...)
          errMsg = errMsg ? `Erreur ${error.status} : ` + errMsg : `Erreur ${error.status} : ${error.error.message}.`;
        }
      }
    } else {
      errMsg = errMsg ? 'Une erreur inconnue s\'est produite : ' + errMsg : error.message ? error.message : error.toString();
    }

    this.notificationService.notify('error', errMsg);


    return throwError(error);
  }

}
